import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import store from '@/store/index';
import { isUndef } from '@/lib/utils';
import HorizontalSlideContainer from '@/components/horizontalSlidePage/horizontalSlideContainer.vue';
import HorizontalSlidePage from '@/components/horizontalSlidePage/horizontalSlidePage.vue';
/**
 * @update(names, ids) 数据更新
 * @finish() 点击最后一级的情况下触发事件，可能使用于当点击最后一级的情况下，将关闭地址选择组件
 */

var DistrictPicker =
/** @class */
function (_super) {
  __extends(DistrictPicker, _super);

  function DistrictPicker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 当前显示的内容 */


    _this.current = 0;
    /** 所有的districtId内容，其中不允许存在null */

    _this.districtIds = [];
    /** 第二级地区列表 */

    _this.level2List = [];
    /** 第三级地区列表 */

    _this.level3List = [];
    return _this;
  }

  Object.defineProperty(DistrictPicker.prototype, "level1List", {
    /** 第一级选择内容 */
    get: function get() {
      var list = store.state.district._provinceList;

      if (this.useExtra) {
        list = store.state.district.extraProvinceList.concat(list);
      }

      return list;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DistrictPicker.prototype, "listMap", {
    /** 所有的list的map */
    get: function get() {
      return store.state.district._listMap;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DistrictPicker.prototype, "districtMap", {
    /** 所有的district的map */
    get: function get() {
      return store.state.district._districtMap;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DistrictPicker.prototype, "lastDistrictId", {
    /**
     * 如果没有的情况下，返回null
     *
     * @return {Number|null} 最后一级districtId，当没有districtIds时候返回null
     */
    get: function get() {
      var len = this.districtIds.length;

      if (len === 0) {
        return null;
      }

      return this.districtIds[len - 1];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DistrictPicker.prototype, "moreColumnVisible", {
    /**
     * 指示下一列是否存在
     *
     * 1. 当前列数>=3的情况 -> false
     * 2. isUndef(lastDistrictId) -> true
     * 3. district的level达到标准的情况下 -> false
     * 4. !list == null && !(list.length === 0)
     */
    get: function get() {
      var _this = this; // 如果列数已经到达了3


      if (this.districtIds.length >= 3) {
        return false;
      } // 如果最后一个districtId不存在情况下，表明当前没有任何级别被选中


      var lastDistrictId = this.lastDistrictId;

      if (isUndef(lastDistrictId)) {
        return true;
      } // 如果lastDistrictId已经到达了最大的level，那么将不显示


      var district = this.districtMap[lastDistrictId];

      if (this.level2 && this.maxLevel === 2 && district.level === 1 && district.is_city) {
        return true;
      }

      if (district && district.level >= this.maxLevel) {
        return false;
      }

      var list = this.listMap[lastDistrictId];

      if (isUndef(list)) {
        return false;
      } // 如果最后一个districtId对应的list是一个空数组的情况下，表明没有下一级了


      list = list.filter(function (district) {
        return district.level <= _this.maxLevel;
      });
      return !isUndef(list) && !(list.length === 0);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DistrictPicker.prototype, "maxColumn", {
    /**
     * 最大的column数量
     *
     * @return {Number} 最大的column存在数量
     */
    get: function get() {
      return this.districtIds.length + (this.moreColumnVisible ? 1 : 0);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DistrictPicker.prototype, "districtNames", {
    /**
     * 所需要显示的面包屑导航
     *
     * - 当没有的情况下，将会默认显示一列内容
     */
    get: function get() {
      var _this = this;

      if (this.districtIds.length > 0) {
        var result = this.districtIds.map(function (districtId) {
          var district = _this.districtMap[districtId];
          return district ? district.name : null;
        });

        if (this.moreColumnVisible) {
          result.push('请选择');
        }

        return result;
      } else {
        return ['请选择'];
      }
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 当districtIds发生变化的时候，需要尝试获取子级行政区的内容
   */

  DistrictPicker.prototype.onDistrictIdsChange = function (ids) {
    var _this = this;

    var maxLevel = this.maxLevel; // 当所有的数据完成之后，在确定需要移动到哪里
    // 显示在不同的list中的内容需要保证level符合要求

    ids.forEach(function (id, index) {
      if (index === 0) {
        var topDistrict_1 = _this.districtMap[id];
        _this.level2List = _this.listMap[id].filter(function (district) {
          if (_this.level2 && maxLevel > 1 && topDistrict_1 && topDistrict_1.is_city) {
            return true;
          }

          return district && district.level <= maxLevel;
        });
      } else if (index === 1) {
        _this.level3List = _this.listMap[id].filter(function (district) {
          return district && district.level <= maxLevel;
        });
      }
    });
  };
  /**
   * 当address被点击
   *
   * @param {} id 行政区id
   * @param {} column 列数，从0开始
   */


  DistrictPicker.prototype.onClickAddressItem = function (id, column) {
    return __awaiter(this, void 0, void 0, function () {
      var ids, names;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            ids = this.districtIds.slice(0, column); // 更新ids

            ids.push(id);
            this.$store.commit('startRequest'); // 获取更新所有的数据

            return [4
            /*yield*/
            , Promise.all(ids.map(function (id) {
              return _this.$store.dispatch('getChildDistricts', {
                id: id
              });
            }))];

          case 1:
            // 获取更新所有的数据
            _a.sent();

            this.$store.commit('endRequest');
            this.districtIds = ids; // 判断是否还有下一列的存在情况下，进入到column的下一列中

            if (column + 2 <= this.maxColumn) {
              this.current = column + 1;
            }

            names = this.moreColumnVisible ? this.districtNames.slice(0, this.districtNames.length - 1) : this.districtNames;
            this.$emit('update', names, ids); // 当没有更多需要显示的情况下，将触发finish事件

            if (!this.moreColumnVisible) {
              this.$emit('finish');
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 点击面包屑的时候
   *
   * @param {} index 导航的位置
   */


  DistrictPicker.prototype.onClickAddressCrumb = function (index) {
    this.current = index;
  }; // 生命周期


  DistrictPicker.prototype.created = function () {
    return __awaiter(this, void 0, void 0, function () {
      var ids;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            ids = (this.defaultDistrictIds || []).filter(function (id) {
              return !isUndef(id);
            }); // 只有在需要的时候才进行请求

            if (ids.length > 0) {
              this.$store.dispatch('getProvinceList');
            } // 获取子级district


            return [4
            /*yield*/
            , Promise.all(ids.map(function (id) {
              return _this.$store.dispatch('getChildDistricts', {
                id: id
              });
            }))];

          case 1:
            // 获取子级district
            _a.sent();

            ids.forEach(function (id, index) {
              Vue.set(_this.districtIds, index, id);
            });
            this.current = ids.length > 0 ? ids.length - 1 : 0;
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  __decorate([Prop({
    type: Array,
    "default": function _default() {
      return [];
    }
  })], DistrictPicker.prototype, "defaultDistrictIds", void 0);

  __decorate([Prop({
    type: Number,
    "default": 3
  })], DistrictPicker.prototype, "maxLevel", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], DistrictPicker.prototype, "useExtra", void 0);

  __decorate([Prop()], DistrictPicker.prototype, "level2", void 0);

  __decorate([Watch('districtIds')], DistrictPicker.prototype, "onDistrictIdsChange", null);

  DistrictPicker = __decorate([Component({
    name: 'DistrictPicker',
    components: {
      HorizontalSlideContainer: HorizontalSlideContainer,
      HorizontalSlidePage: HorizontalSlidePage
    }
  })], DistrictPicker);
  return DistrictPicker;
}(Vue);

export default DistrictPicker;